import React, { useState, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { AuthGuard } from '@/components/auth/auth-guard';
import { DynamicLayout } from '@/components/dashboard/layout/dynamic-layout';

import DataContext from '@/contexts/DataContext';
import { baseMenuConfig } from './baseMenuConfig';
import { logger } from '@/lib/default-logger';

export function Layout({ children }) {
  const location = useLocation();
  const [user, setUser] = useState("");
  const [projects, setProjects] = useState(null);
  const [appsAndViews, setAppsAndViews] = useState(null);
  const [menuConfig, setMenuConfig] = useState([baseMenuConfig]);
  const [currentProject, setCurrentProject] = useState({name: 'Select a project', avatar: '/assets/logos/clistek-icon-white-logo.png', id: null});
  const [alerts, setAlerts] = useState([]);
  const [currentAlert, setCurrentAlert] = useState(null);
  const [historianParams, setHistorianParams] = useState({});
  const [currentApp, setCurrentApp] = useState(null);
  const [currentView, setCurrentView] = useState(null);
  const [viewParams, setViewParams] = useState([]);
  const [prelimParamCount, setPrelimParamCount] = useState(0); // #of params that need to be selected before the page contents can render
  const [selectedViewParams, setSelectedViewParams] = useState({});
  const [changedParams, setChangedParams] = useState([]);
  // const [requestedURL, setRequestedURL] = useState(window.location.pathname);
  const [requestedURL, setRequestedURL] = useState(location);
  const [previousURL, setPreviousURL] = useState(null);
  const [externalURL, setExternalURL] = useState(true);
  const [doneValidating, setDoneValidating] = useState(false);

  // localStorage.setItem("requestedURL", window.location);
  localStorage.setItem("requestedURL", JSON.stringify(location));

  // useEffect(() => {
  //   logger.debug('set params: layout', currentView, viewParams, selectedViewParams);
  //   setViewParams([])
  //   setSelectedViewParams({});
  // }, [currentView]);

  // useEffect(() => {
  //   let shouldReset = true;
  //   if (currentView?.viewData?.parameters) {
  //     let curParams = currentView.viewData.parameters;
  //     if (curParams.length === viewParams.length) {
  //       shouldReset = false;
  //       for (let i = 0; i < curParams.length; i++) {
  //         if (curParams[i] !== viewParams[i]) shouldReset = true;
  //       }
  //     } 
  //   } 

  //   logger.debug('set params: layout', shouldReset, currentView, viewParams, selectedViewParams);
  //   if (shouldReset) {
  //     setViewParams([]);
  //     setSelectedViewParams({});
  //   }

  // }, [currentView]);

  useEffect(() => {
    logger.debug('new params', viewParams);
  }, [viewParams]);

  useEffect(() => {
    logger.debug('prev url change', previousURL)
  }, [previousURL])


  const value = useMemo(() => ({
    user, setUser, projects, setProjects, appsAndViews, setAppsAndViews, currentProject, setCurrentProject, alerts, setAlerts, currentAlert, setCurrentAlert, historianParams, setHistorianParams, currentApp, setCurrentApp, currentView, setCurrentView, viewParams, setViewParams, prelimParamCount, setPrelimParamCount, selectedViewParams, setSelectedViewParams, changedParams, setChangedParams, menuConfig, setMenuConfig, requestedURL, setRequestedURL, previousURL, setPreviousURL, externalURL, setExternalURL, doneValidating, setDoneValidating
  }), [user, projects, appsAndViews, currentProject, alerts, currentAlert, historianParams, currentApp, currentView, viewParams, prelimParamCount, selectedViewParams, changedParams, menuConfig, requestedURL, previousURL, externalURL, doneValidating]);


  return (
      <AuthGuard>
        {/* <DataContext.Provider value={{ user, setUser, projects, setProjects, appsAndViews, setAppsAndViews, currentProject, setCurrentProject, alerts, setAlerts, currentAlert, setCurrentAlert, currentApp, setCurrentApp, currentView, setCurrentView, viewParams, setViewParams, prelimParamCount, setPrelimParamCount, selectedViewParams, setSelectedViewParams, changedParams, setChangedParams, menuConfig, setMenuConfig, requestedURL, setRequestedURL, previousURL, setPreviousURL, externalURL, setExternalURL, doneValidating, setDoneValidating }}> */}
        <DataContext.Provider value={value}>
          <DynamicLayout>{children}</DynamicLayout>
        </DataContext.Provider>
      </AuthGuard>
  );
}
